import * as React from 'react';
import { memo } from 'react';

const SvgCaretLeft = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m7.5 10.445-3.75-3.75 3.75-3.75", stroke: "#fff", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgCaretLeft);

export { Memo as default };
